// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb2e9b04","455":"601ae61d"}[chunkId] + ".chunk.js";
};